/** Keep shipment validation aligned with the API; address-book contacts may omit a phone. */
export function recipientPhoneIssue(value: unknown): string | null {
  if (value === undefined || value === null || (typeof value === 'string' && !value.trim())) {
    return 'Recipient phone number is required to create a label.';
  }
  if (typeof value !== 'string') return 'Recipient phone number must include between 7 and 15 digits.';
  const phone = value.trim();
  const digits = phone.replace(/\D/g, '');
  if (phone.length > 32 || !/^[+\d().\-\s]+$/.test(phone) || digits.length < 7 || digits.length > 15) {
    return 'Recipient phone number must include between 7 and 15 digits.';
  }
  return null;
}
